import api from "api";
import {setPages} from "../pages/actions";
import {setSurvey} from "../survey/actions";
import {SET, SET_QUESTION_RESPONSE, UNSET_QUESTION_RESPONSE} from "./actionTypes";
import {setProgress} from "../progress/actions";
import {startMeasuring} from "../timeMeasuring/actions";
import {setUser} from "../user/actions";
import {setQuestionResponses} from "../questionResponses/actions";
import axios from "axios";

export function setSurveyResponse(surveyResponse) {
  return {
    type: SET,
    surveyResponse
  }
}

export function setQuestionResponse(questionResponse) {
  return {
    type: SET_QUESTION_RESPONSE,
    questionResponse
  }
}

export function unsetQuestionResponse(question) {
  return dispatch => {
    dispatch({
      type: UNSET_QUESTION_RESPONSE,
      question
    });
  };
}

export function getQuestionsListPreview(data) {
  return dispatch => {
    return api.surveyResponse.get.questionsListPreview(data)
      .then((data) => {
        dispatch(startMeasuring(0));

        dispatch(setProgress(data.progress));
        dispatch(setSurvey(data.surveyResponse.survey));
        dispatch(setPages(data.pages));
        dispatch(setSurveyResponse(data.surveyResponse));

        return data;
      })
  }
}

export function getSurveyResponse(data) {
  return dispatch => {
    return api.surveyResponse.get.surveyResponse(data)
      .then((data) => {
        dispatch(startMeasuring(Date.now() - data.surveyResponse.microTime));

        dispatch(setProgress(data.progress));
        dispatch(setSurvey(data.surveyResponse.survey));
        dispatch(setPages(data.pages));
        dispatch(setSurveyResponse(data.surveyResponse));
        if(data.surveyResponse.user){
          dispatch(setUser(data.surveyResponse.user));
        }

        document.title = data.surveyResponse.survey.nameOryginal + ' | ANKIETEO';
        const description = document.querySelector('meta[name="description"]');
        if (description) {
            description.setAttribute("content", data.surveyResponse.invitationText);
        }
        document.querySelector('meta[name="keywords"]').setAttribute("content", 'ankieta, ankieteo, ankietheo, ' + data.surveyResponse.survey.nameOryginal);

        return data;
      })
  }
}

export function postSurveyResponse(data) {
  return dispatch => {
    return api.surveyResponse.post.surveyResponse(data)
      .then((data) => {
        axios.defaults.headers.common.surveyResponseKey = data.surveyResponseKey;
        dispatch(startMeasuring(Date.now() - data.surveyResponse.microTime));

        dispatch(setProgress(data.progress));
        dispatch(setSurvey(data.surveyResponse.survey));
        dispatch(setPages(data.pages));
        dispatch(setSurveyResponse(data.surveyResponse));
        if(data.surveyResponse.user){
          dispatch(setUser(data.surveyResponse.user));
        }

        document.title = data.surveyResponse.survey.nameOryginal + ' | ANKIETEO';
        const description = document.querySelector('meta[name="description"]');
        if (description) {
            description.setAttribute("content", data.surveyResponse.invitationText);
        }
        document.querySelector('meta[name="keywords"]').setAttribute("content", 'ankieta, ankieteo, ankietheo, ' + data.surveyResponse.survey.nameOryginal);

        return data;
      })
  }
}

export function postQuestionResponses(data) {
  return dispatch => {
    return api.surveyResponse.post.questionResponse(data).then((resData) => {
      if(resData.hasOwnProperty('redirect')) {
        window.location.href = resData.redirect;
      } else {
        if('_direction' in data){
          dispatch(setPages(resData.pages));
          if(data._direction !== 0){
            dispatch(setQuestionResponses({}));
          }
        }

        if(resData.surveyResponse.status === 2) {
            dispatch(setSurveyResponse(resData.surveyResponse));
        }

        if(resData.surveyResponse.isEnded){
          dispatch(setSurveyResponse(resData.surveyResponse));
          if(resData.surveyResponse.user){
            dispatch(setUser(resData.surveyResponse.user));
          }
        }

        if(resData.progress){
          dispatch(setProgress(resData.progress));
        }
        return resData;
      }
    })
  }
}